define('rebrush/components/blocks/cliplister/3dgallery',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'cartware/components/Config',
    'qrious'
], function(
    $,
    _,
    Component,
    BEM,
    Config,
    QR
) {
    const BLOCK_NAME = 'cliplister-3dgallery';

    let instanceCount = 0;

    const componentSymbol = Symbol();

    function Cliplister3DGallery(block) {
        this.instanceId = instanceCount++;
        this.block = BEM.block(block);
        this.block.attr('id', 'Cliplister3DGallery_' + this.instanceId);

        this.settings = this.block.data('cliplister-settings');

        this.scriptSrc = Config.get('cliplister.scriptSrc');
        this.customerId = Config.get('cliplister.customerId');
        this.init();
    }

    Cliplister3DGallery.prototype = {
        init: function() {
            const trigger = 'trigger' in this.settings ? this.settings.trigger : 'auto';
            const self = this;

            if (trigger === 'auto') {
                this.injectScript();
            } else if (trigger === 'observer') {
                let observer;
                const check = () => {
                    if (this.block.is(':visible')) {
                        this.injectScript();
                        observer && observer.disconnect();
                    }
                };

                observer = new MutationObserver(check);
                observer.observe(document.body, { attributes: true, childList: true, subtree: true });
            } else {
                (typeof console !== 'undefined') && console.warn('Trigger "' + trigger + '" not supported');
            }
        },

        injectScript: function() {
            var self = this;
            var callbackName = 'Cliplister3DGallery_callback_' + this.instanceId;
            window['QRious'] = QR;
            window[callbackName] = function() {
                new Cliplister.Viewer({
                    //parentId: 'viewer',
                    parentId: 'Cliplister3DGallery_' + self.instanceId,
                    customer: self.customerId,
                    assettype: 'data',
                    assetkind: '3Dasset',
                    assets: 'assets' in self.settings ? self.settings.assets : [],
                    keyType: '30000',
                    backgroundColor: '#FFF',
                    stage: {
                        width: '100%',
                        aspectRatio: 'asset',
                        cameraControls: true,
                        autoRotate: true,
                        arEnabled: true,
                        arScale: 0.5,
                        environment: 'neutral'
                    },
                    plugins: {
                        Controls3D: {
                            layer: 1,
                            template: {
                                type: 'external',
                                source: 'https://mycliplister.com/static/viewer/assets/skins/default/controls-3d_2.html'
                            },
                            qrcode: true
                        },
                        QRCode: {
                            layer: 2,
                            id: 'qrcode'
                        }
                    }
                });
            };

            var script = document.createElement('script');
            script.setAttribute('src', this.scriptSrc);
            script.setAttribute('type', 'module');
            script.setAttribute('onload', callbackName + '()');

            document.head.appendChild(script);
        }
    };

    return Component.create({
        constructor: function() {
            this.onChange = _.bind(this.transform, this);
        },

        $init: function() {
            if (!Config.get('cliplister.active')) {
                return;
            }
            $(document).on('product/changeGallerySimple', this.onChange);
            $(document).on('product/changeGalleryPicture', this.onChange);
            this.transform();
        },

        destructor: function() {
            $(document).off('product/changeSimple', this.onChange);
            $(document).off('product/changeGallerySimple', this.onChange);
        },

        transform: function() {
            BEM.block(BLOCK_NAME).each(function() {
                if (!(componentSymbol in this)) {
                    this[componentSymbol] = new Cliplister3DGallery(this);
                }
            });
        }
    });
});
